import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Bid, Project } from '@freelancer/datastore';
import * as Rx from 'rxjs';

@Component({
  template: `
    <app-expanded-bid [bid$]="bid$" [project$]="project$"></app-expanded-bid>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandedBidOverlayComponent {
  @Input() bid$: Rx.Observable<Bid>;
  @Input() project$: Rx.Observable<Project>;
}
